module.exports = __webpack_public_path__ + "img/shipinyinliao.fe6f3169.png";